import { render, staticRenderFns } from "./modalHistoryResults.vue?vue&type=template&id=63b7a5ae&"
import script from "./modalHistoryResults.vue?vue&type=script&lang=js&"
export * from "./modalHistoryResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports